import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Chip,
} from '@mui/material';
import {
  Work,
  Schedule,
  Assignment,
  Security,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Welcome back, {user?.firstName}!
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Here's what's happening with your construction projects today.
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 4 }}>
        <Card sx={{ minWidth: 200, flex: 1 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Avatar sx={{ bgcolor: 'black', mr: 2 }}>
                <Work sx={{ color: 'white' }} />
              </Avatar>
              <Box>
                <Typography variant="h4" component="div" fontWeight="bold">
                  8
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Active Projects
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Avatar sx={{ bgcolor: 'black', mr: 2 }}>
                <Schedule sx={{ color: 'white' }} />
              </Avatar>
              <Box>
                <Typography variant="h4" component="div" fontWeight="bold">
                  156
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Timesheets
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Avatar sx={{ bgcolor: 'black', mr: 2 }}>
                <Assignment sx={{ color: 'white' }} />
              </Avatar>
              <Box>
                <Typography variant="h4" component="div" fontWeight="bold">
                  5
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Pending Reports
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Avatar sx={{ bgcolor: 'black', mr: 2 }}>
                <Security sx={{ color: 'white' }} />
              </Avatar>
              <Box>
                <Typography variant="h4" component="div" fontWeight="bold">
                  2
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Safety Incidents
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            Quick Actions
          </Typography>
          
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Chip
              icon={<Schedule />}
              label="Submit Timesheet"
              clickable
              variant="outlined"
              sx={{ 
                borderColor: 'black',
                color: 'black',
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white'
                }
              }}
            />
            
            <Chip
              icon={<Assignment />}
              label="Create Daily Report"
              clickable
              variant="outlined"
              sx={{ 
                borderColor: 'black',
                color: 'black',
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white'
                }
              }}
            />
            
            <Chip
              icon={<Security />}
              label="Report Safety Issue"
              clickable
              variant="outlined"
              sx={{ 
                borderColor: 'black',
                color: 'black',
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white'
                }
              }}
            />
            
            <Chip
              icon={<Work />}
              label="View Projects"
              clickable
              variant="outlined"
              sx={{ 
                borderColor: 'black',
                color: 'black',
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white'
                }
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Dashboard;